import { TextStyle } from "pixi.js";

export const levelFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: "100",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeThickness: 2,
    letterSpacing: 10,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const mapLevel = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: "300",
    fill: "#ffffff",
    stroke: "#000000",
    strokeThickness: 3,
    letterSpacing: 10,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const mapLevelLocked = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: "300",
    fill: "#ffffff",
    stroke: "#000000",
    strokeThickness: 3,
    letterSpacing: 1,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const statsFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: "100",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeThickness: 1,
    letterSpacing: 7,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const victoryFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: "400",
    fill: "#1a5216",
    stroke: "#ffffff",
    strokeThickness: 3,
    letterSpacing: 20,
    dropShadow: true,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const subVictoryFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: "100",
    fill: "#ffffff",
    stroke: "#000000",
    strokeThickness: 1,
    letterSpacing: 20,
    dropShadow: true,
    wordWrap: true,
    wordWrapWidth: 600,
});

export const defeatFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: "400",
    fill: "#ff0000",
    stroke: "#ffffff",
    strokeThickness: 3,
    letterSpacing: 20,
    dropShadow: true,
    wordWrap: true,
    wordWrapWidth: 440,
});

export const subDefeatFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: "100",
    fill: "#ffffff",
    stroke: "#000000",
    strokeThickness: 1,
    letterSpacing: 20,
    dropShadow: true,
    wordWrap: true,
    wordWrapWidth: 600,
});

export const LoadingInfoFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 40,
    fontWeight: "400",
    fill: "#000000",
    stroke: "#ffffff",
    strokeThickness: 1,
    letterSpacing: 20,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 600,
});

export const screenTooSmallFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: "200",
    fill: "#ffffff",
    stroke: "#000000",
    strokeThickness: 8,
    letterSpacing: 1,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 600,
});

export const discountInfoFont = new TextStyle({
    align: "center",
    fontFamily: "\"Source Sans Pro\", Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: "400",
    fill: "#150117",
    stroke: "#d2bcd4",
    strokeThickness: 1,
    letterSpacing: 1,
    dropShadow: false,
    wordWrap: true,
    wordWrapWidth: 600,
});
